import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { IdvService } from '@shared/services/idv.service';
import { APP_CONFIG, AppConfig } from '@src/app/app-config.module';
import { NGXLogger } from 'ngx-logger';

@Component({
    selector: 'static-pre-idv-page',
    templateUrl: './static-pre-idv-page.component.html',
    styleUrl: './static-pre-idv-page.component.scss'
})
export class StaticPreIdvPageComponent implements OnInit {
    loading: boolean = true;
    idvHelpPageUrl: string = null;
    privacyPolicyLink: string = null;

    necessaryIdvSteps: string[] = [
        "STEP_OPEN_LINK",
        "STEP_UPLOAD_ID",
        "STEP_UPLOAD_POA",
        "STEP_RECORD_VIDEO"
    ];

    constructor(
        @Inject(APP_CONFIG) private readonly config: AppConfig,
        private readonly logger: NGXLogger,
        private readonly router: Router,
        private readonly translateService: TranslateService,
        private readonly idvService: IdvService
    ) { }

    ngOnInit(): void {
        const idvData = this.idvService.getCurrentIdvSessionData();

        this.logger.debug("idvData", idvData);
        this.privacyPolicyLink = this.config.privacyPolicyLink[this.translateService.getCurrentLang()];

        this.translateService.onLangChange.subscribe(e => {
            this.handleLanguageChange(e.lang);
        });
        this.handleLanguageChange(this.translateService.getCurrentLang());
        this.loading = false;
    }

    handleLanguageChange(lang: string) {
        switch (lang) {
            case "en":
                this.privacyPolicyLink = this.config.privacyPolicyLink.en;
                this.idvHelpPageUrl = this.config.registrationProcessHelpURLs.fallback;
                break;
            case "it":
                this.privacyPolicyLink = this.config.privacyPolicyLink.it;
                this.idvHelpPageUrl = this.config.registrationProcessHelpURLs.ITA;
                break;
            default:
                this.privacyPolicyLink = this.config.privacyPolicyLink.fallback;
                this.idvHelpPageUrl = this.config.registrationProcessHelpURLs.fallback;
                break;
        }
    }

    proceedToIDV(): void {
        this.router.navigate([`static/verify-with-onfido`]);
    }
}
